// --- Flash engelleme: tema popup'ı açmadan önce yazıyı biz basıyoruz ---
(function () {
  var plannedQty = 1;

  function setPlannedQtyFromForm(form) {
    try {
      var qtyEl = form.querySelector('input[name="quantity"]');
      var v = qtyEl ? Number(qtyEl.value) : 1;
      plannedQty = (v && v > 0) ? v : 1;
    } catch (e) {
      plannedQty = 1;
    }
  }

  function writeQtyImmediately() {
    var content = document.querySelector('[data-halo-warning-content]');
    if (!content) return;
    content.innerHTML = plannedQty + ' ürün eklendi';
  }

  // 1) /cart/add'a giden formlar submit olunca (en genel ve sağlam)
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart/add') === -1) return;

      setPlannedQtyFromForm(form);
      writeQtyImmediately(); // popup açılmadan önce içerik hazır
    },
    true // capture: temanın handler'ından önce çalışsın
  );

  // 2) Bazı yerlerde AJAX buton click ile gidiyorsa (yedek)
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('button[name="add"], button[type="submit"], [data-add-to-cart]');
      if (!btn) return;

      var form = btn.closest('form');
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        setPlannedQtyFromForm(form);
        writeQtyImmediately();
      }
    },
    true
  );

  // 3) Ekstra güvenlik: tema sonradan "başarıyla eklendi" yazarsa yine geri çevir
  var content = document.querySelector('[data-halo-warning-content]');
  if (content) {
    var obs = new MutationObserver(function () {
      var t = (content.textContent || '').toLowerCase();
      if (t.includes('başarıyla') || t.includes('success') || t.includes('added')) {
        content.innerHTML = plannedQty + ' ürün eklendi';
      }
    });
    obs.observe(content, { childList: true, subtree: true, characterData: true });
  }
})();